import { ops } from './ops';
import { and, not } from './ruleHelpers';
import { deny, isAdminOrOwner, isAdminOwnerAgentAdvizorOrViewer, isAdminOwnerAgentOrAdvizor, isAdminOwnerOrAdvizor, isMe, isNetwork, isOptionFreemiumOrOrganizationPremium, isOrganizationPremium, isOwner, isPlotArchived, isStaffOrSuperuser } from './rules';
export const policies = {
    user: {
        [ops.requestChargeableOption]: {
            networks: isAdminOrOwner
        },
        [ops.leave]: {
            networks: isOwner,
            organizations: not(isOwner)
        },
        [ops.requestMembership]: {
            // The requesting organization should also not be a network
            // But this make no sense to enforce it here
            networks: isOwner
        },
        [ops.archive]: {
            plots: isAdminOwnerAgentOrAdvizor
        },
        [ops.create]: {
            alerts: isOrganizationPremium,
            plots: isAdminOwnerAgentOrAdvizor,
            thresholdsProfile: isAdminOwnerOrAdvizor,
            stations: isAdminOwnerOrAdvizor
        },
        [ops.view]: {
            alerts: isOrganizationPremium,
            billing: isAdminOwnerAgentOrAdvizor,
            billingPaymentMethodScreen: isOwner,
            billingScreen: isAdminOrOwner,
            debugMode: isStaffOrSuperuser,
            deviceMeasures: isAdminOwnerAgentAdvizorOrViewer,
            devices: isAdminOwnerAgentAdvizorOrViewer,
            members: isAdminOwnerAgentAdvizorOrViewer,
            networkOptionRequests: isAdminOwnerOrAdvizor,
            networkOrganizations: and(isNetwork, isAdminOwnerAgentOrAdvizor),
            networkOrganizationsPlots: isAdminOwnerAgentOrAdvizor,
            networks: isAdminOwnerAgentAdvizorOrViewer,
            optionActivations: isAdminOwnerAgentAdvizorOrViewer,
            options: isAdminOwnerAgentAdvizorOrViewer,
            organizationInvitations: isAdminOwnerAgentOrAdvizor,
            organizationNetworkAdministrationScreen: and(isNetwork, isAdminOwnerAgentOrAdvizor),
            organizationNetworks: and(not(isNetwork), isAdminOwnerAgentAdvizorOrViewer),
            organizations: isAdminOwnerAgentAdvizorOrViewer,
            plotOptionActivations: isAdminOwnerAgentAdvizorOrViewer,
            stationOptionActivations: isAdminOwnerAgentAdvizorOrViewer,
            plots: isAdminOwnerAgentAdvizorOrViewer,
            stations: isAdminOwnerAgentAdvizorOrViewer
        },
        [ops.edit]: {
            alerts: isOrganizationPremium,
            billing: isAdminOrOwner,
            crops: isAdminOwnerAgentOrAdvizor,
            devices: isAdminOwnerAgentOrAdvizor,
            DSSs: isAdminOwnerAgentOrAdvizor,
            members: and(isAdminOrOwner, isOrganizationPremium),
            networks: and(isNetwork, isAdminOrOwner),
            options: isAdminOwnerAgentOrAdvizor,
            organizationNetworks: isAdminOwnerAgentOrAdvizor,
            organizations: isAdminOrOwner,
            plotOptionActivations: isAdminOwnerAgentOrAdvizor,
            stationOptionActivations: isAdminOwnerAgentOrAdvizor,
            plots: and(isAdminOwnerAgentOrAdvizor, not(isPlotArchived)),
            thresholdsProfile: isAdminOwnerOrAdvizor,
            stations: isAdminOwnerOrAdvizor
        },
        [ops.delete]: {
            alerts: isOrganizationPremium,
            members: and(and(isAdminOrOwner, not(isMe)), isOrganizationPremium),
            organizations: deny,
            plotOptionActivations: isAdminOwnerAgentOrAdvizor,
            stationOptionActivations: isAdminOwnerAgentOrAdvizor,
            plots: isAdminOwnerAgentOrAdvizor,
            thresholdsProfile: isAdminOwnerOrAdvizor,
            stations: isAdminOwnerOrAdvizor
        },
        [ops.transferOwnership]: {
            organizations: and(isOwner, not(isMe))
        },
        [ops.linkDevice]: {
            organizations: isAdminOwnerAgentOrAdvizor,
            plots: isAdminOwnerAgentOrAdvizor
        },
        [ops.unlinkDevice]: {
            organizations: isAdminOwnerAgentOrAdvizor,
            plots: isAdminOwnerAgentOrAdvizor
        },
        [ops.activateOption]: {
            plots: and(isAdminOwnerAgentOrAdvizor, isOptionFreemiumOrOrganizationPremium),
            stations: isAdminOwnerOrAdvizor
        },
        [ops.buy]: {
            options: and(isAdminOwnerOrAdvizor, isOptionFreemiumOrOrganizationPremium)
        },
        [ops.start]: {
            cycles: isAdminOwnerAgentOrAdvizor
        },
        [ops.end]: {
            cycles: isAdminOwnerAgentOrAdvizor
        },
        [ops.exportList]: {
            devices: isAdminOwnerAgentOrAdvizor,
            invitations: isAdminOwnerAgentOrAdvizor,
            members: isAdminOwnerAgentOrAdvizor,
            networkOrganizations: isAdminOwnerAgentOrAdvizor,
            plots: isAdminOwnerAgentOrAdvizor
        }
    }
};
